import React, { FC } from 'react'
import { EditMediaElement } from '../topic-detail-page/components/video-element/EditMediaElement'
import EditLinkElement from '../topic-detail-page/components/link-element/EditLinkElement'
import EditDocumentElement from '../topic-detail-page/components/document-element/EditDocumentElement'
import TextElement from '../topic-detail-page/components/text-element/TextElement'

import { EditQuizElement } from '../topic-detail-page/components/quiz-element/EditQuizElement'

import {
  TopicElementTypeEnum,
  QuizElementTypes
} from '../../../../types/TopicElementTypeEnum'
import {
  TopicElementModelAsEditor,
  TopicModelAsEditor,
  TopicModelAsMember
} from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { EditEmbeddedFileElement } from '../topic-detail-page/components/edit-embedded-file-element/EditEmbeddedFileElement'
import EditEmbedLinkElement from '../topic-detail-page/components/embed-link-element/EditEmbedLinkElement'

export const EditElement: FC<{
  element: TopicElementModelAsEditor
  topic: TopicModelAsEditor | TopicModelAsMember // TODO it would make sense to only need TopicModelAsEditor type here, but it would probably require a bigger refactor
  isMultiPage: boolean
}> = (props) => {
  const { element } = props
  const { type } = element

  const elementType = type as any as TopicElementTypeEnum
  if (QuizElementTypes.includes(elementType)) {
    return <EditQuizElement key={element.id} {...props} />
  }

  // "key" attribute is needed for all elements when in multi page mode
  switch (elementType) {
    case TopicElementTypeEnum.DOCUMENT:
      return <EditDocumentElement key={element.id} {...props} />

    case TopicElementTypeEnum.TEXT:
      return <TextElement key={element.id} {...props} />

    case TopicElementTypeEnum.LINK:
      return <EditLinkElement key={element.id} {...props} />

    case TopicElementTypeEnum.MEDIA:
      return <EditMediaElement key={element.id} {...props} />

    case TopicElementTypeEnum.GOOGLE_DRIVE_FILE:
      return <EditEmbeddedFileElement key={element.id} {...props} />

    case TopicElementTypeEnum.MICROSOFT_FILE:
      return <EditEmbeddedFileElement key={element.id} {...props} />

    case TopicElementTypeEnum.EMBED_LINK:
      return <EditEmbedLinkElement key={element.id} {...props} />

    default:
      return <div>{type}</div>
  }
}
